export const BUSINESS_NAME_OWNER = {
  CLIENT: "client",
  COMPANY: "company",
  CONTRACTOR: "contractor"
}

const resourceConfig = {
  [BUSINESS_NAME_OWNER.CLIENT]: {
    collection: "api/clients/business_name",
    list: (ownerId) => `api/clients/taxt_data/${ownerId}`,
    profile: (ownerId) => `/users/clients/show/${ownerId}`,
    ownerKey: "client_id",
    label: "Clientes"
  },
  [BUSINESS_NAME_OWNER.COMPANY]: {
    collection: "api/companies/business_name",
    list: (ownerId) => `api/companies/${ownerId}/tax_data`,
    profile: (ownerId) => `/companies/${ownerId}`,
    ownerKey: "company_id",
    label: "Empresas"
  },
  [BUSINESS_NAME_OWNER.CONTRACTOR]: {
    collection: "api/contractors/business_name",
    list: (ownerId) => `api/contractors/${ownerId}/tax_data`,
    profile: (ownerId) => `/contractors/${ownerId}`,
    ownerKey: "contractor_id",
    label: "Contratistas"
  }
}

export const normalizeBusinessNameOwner = (ownerType) => {
  if (ownerType === "companies") return BUSINESS_NAME_OWNER.COMPANY
  if (ownerType === "contractors") return BUSINESS_NAME_OWNER.CONTRACTOR
  if (ownerType === "clients") return BUSINESS_NAME_OWNER.CLIENT
  return resourceConfig[ownerType] ? ownerType : BUSINESS_NAME_OWNER.CLIENT
}

export const getBusinessNameResource = (ownerType) => resourceConfig[normalizeBusinessNameOwner(ownerType)]

export const getBusinessNameProfile = (ownerType, ownerId, userRole) => {
  const normalizedOwner = normalizeBusinessNameOwner(ownerType)

  if (
    normalizedOwner === BUSINESS_NAME_OWNER.COMPANY &&
    userRole === BUSINESS_NAME_OWNER.COMPANY
  ) {
    return "/company/settings"
  }

  if (
    normalizedOwner === BUSINESS_NAME_OWNER.CONTRACTOR &&
    userRole === BUSINESS_NAME_OWNER.CONTRACTOR
  ) {
    return "/contractor/settings"
  }

  return getBusinessNameResource(normalizedOwner).profile(ownerId)
}

export const getBusinessNameRoutes = (ownerType, ownerId, taxDataId = null) => {
  const normalizedOwner = normalizeBusinessNameOwner(ownerType)
  const base = `/business-names/${normalizedOwner}/${ownerId}`

  return {
    new: `${base}/new`,
    show: taxDataId ? `${base}/${taxDataId}/show` : null,
    edit: taxDataId ? `${base}/${taxDataId}/edit` : null,
    profile: getBusinessNameResource(normalizedOwner).profile(ownerId)
  }
}

export const getOwnerPayload = (ownerType, ownerId) => {
  const resource = getBusinessNameResource(ownerType)
  return {
    [resource.ownerKey]: ownerId
  }
}

export const normalizeTaxDataCollection = (payload) => {
  const data = payload?.data ?? payload
  const rows = Array.isArray(data)
    ? data
    : Array.isArray(data?.data)
      ? data.data
      : []

  return {
    data: rows,
    meta: data?.meta ?? {
      current_page: 1,
      last_page: 1,
      total: rows.length
    }
  }
}
